import { render, staticRenderFns } from "./feetscare-stat.vue?vue&type=template&id=651f4a4e&scoped=true&"
import script from "./feetscare-stat.vue?vue&type=script&lang=js&"
export * from "./feetscare-stat.vue?vue&type=script&lang=js&"
import style0 from "./feetscare-stat.vue?vue&type=style&index=0&id=651f4a4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f4a4e",
  null
  
)

export default component.exports